import { render, staticRenderFns } from "./RegistrationModal.vue?vue&type=template&id=cba43918&"
import script from "./RegistrationModal.vue?vue&type=script&lang=js&"
export * from "./RegistrationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node/your.borobudurmarathon.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cba43918')) {
      api.createRecord('cba43918', component.options)
    } else {
      api.reload('cba43918', component.options)
    }
    module.hot.accept("./RegistrationModal.vue?vue&type=template&id=cba43918&", function () {
      api.rerender('cba43918', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RegistrationModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/RegistrationModal.vue
// module id = 624
// module chunks = 0